import React from "react";
import {LatLng} from "leaflet";
import MapDisplay from "../../map/components/MapDisplay";
import {Marker} from "react-leaflet";
import MarkerIconService from "../../../services/map/MarkerIconService";
import GPSCoordinates from "../../../models/GPSCoordinates";

/**
 * Displays a single marker on a map.
 * @author Alizée Grand
 * @version 1.0
 * @creation 20/04/2022
 * @last_update 25/04/2022
 **/
class DisplayCurrentGeolocation extends React.Component<{
    /**
     * Coordinates of the marker to be displayed.
     */
    location: GPSCoordinates
}> {

    render() {

        /**
         * Converts the position of the marker into a format that Leaflet can understand.
         * @return {LatLng}
         */
        const getLocationToLatLng = () => {
            return new LatLng(this.props.location.latitude, this.props.location.longitude)
        }

        /**
         * Marker to display.
         * @type {JSX.Element}
         */
        const marker: JSX.Element = (
            <Marker
                position={getLocationToLatLng()}
                icon={MarkerIconService.getBasicIcon()}
            />
        );

        return (
            <MapDisplay gpsCoordinates={[getLocationToLatLng()]} markers={[marker]}/>
        );

    };

}

export default DisplayCurrentGeolocation;
